module.exports = __webpack_public_path__ + "img/20_6.2a7d12a0.png";